import React from 'react';
import type {Location} from '../api/types';
import {MyWeather} from '../utils';
import useMissingPlaceForecastModels from './useMissingPlaceForecastModels';
import usePlacesNow from './usePlacesNow';

/**
 * The current hour of every place a My weather list shows, and of the
 * current position, in one batched request kept for the session (FE #381).
 * Both apps' lists: each passes the sections it draws, and `here` only when
 * its Current location card shows the hour.
 *
 * The places' model lists are fetched too, as the favourites already get
 * theirs: a row asks for the model its screen shows, which needs the
 * place's list, and a row whose list is on its way waits for it (`hold`).
 */
const useMyWeatherNow = (
  sections: MyWeather.MyWeatherSection[],
  here: Location | null,
) => {
  const places = React.useMemo(() => {
    const listed = MyWeather.sectionPlaces(sections);
    return here ? [here, ...listed] : listed;
  }, [sections, here]);
  const hold = useMissingPlaceForecastModels({also: places});
  return usePlacesNow(places, {hold});
};

export default useMyWeatherNow;
